var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UtilisateurMenu',{scopedSlots:_vm._u([{key:"header-buttons",fn:function(){return [_vm._t("header-buttons")]},proxy:true}],null,true)}),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }